import { AsyncThunkPayloadCreator, createAsyncThunk } from '@reduxjs/toolkit';
import apiClient from '../../api/api-client';
import { GenerelConfig, Product } from '../../types';
import { SearchProductsRequest } from '../types';
import { RootState } from '../store';

export const THUNK_NAMES = {
  GET_PRODUCTS: 'getProducts',
  GET_MORE_PRODUCTS: 'getMoreProducts',
  GET_GENERAL_CONFIG: 'getGenerelConfig'
};

const getProductsQuery: AsyncThunkPayloadCreator<Product[], void> = async (
  _: void,
  { getState }
) => {
  const state = getState() as RootState;
  const queryParams: SearchProductsRequest = state.products.queryParams;
  return apiClient.getProducts(queryParams);
};

export const getProducts = createAsyncThunk<Product[]>(
  `products/${THUNK_NAMES.GET_PRODUCTS}`,
  getProductsQuery
);

export const getMoreProducts = createAsyncThunk<Product[]>(
  `products/${THUNK_NAMES.GET_MORE_PRODUCTS}`,
  getProductsQuery
);

export const getGeneralConfig = createAsyncThunk<GenerelConfig>(
  `products/${THUNK_NAMES.GET_GENERAL_CONFIG}`,
  async () => apiClient.getGeneralConfig()
);
